import _regeneratorRuntime from "/Users/szymon/Documents/Projects/Dacein/Code/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/Users/szymon/Documents/Projects/Dacein/Code/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/Users/szymon/Documents/Projects/Dacein/Code/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/Users/szymon/Documents/Projects/Dacein/Code/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/szymon/Documents/Projects/Dacein/Code/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/szymon/Documents/Projects/Dacein/Code/node_modules/@babel/runtime/helpers/esm/inherits";
import _wrapNativeSuper from "/Users/szymon/Documents/Projects/Dacein/Code/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
var metas = new Map();
var queue = [];
var map = queue.map;
var some = queue.some;
var hasOwnProperty = queue.hasOwnProperty;
var origin = "https://cdn.jsdelivr.net/npm/";
var identifierRe = /^((?:@[^/@]+\/)?[^/@]+)(?:@([^/]+))?(?:\/(.*))?$/;
var versionRe = /^\d+\.\d+\.\d+(-[\w-.+]+)?$/;
var extensionRe = /\.[^/]*$/;
var mains = ["unpkg", "jsdelivr", "browser", "main"];
export var RequireError =
/*#__PURE__*/
function (_Error) {
  _inherits(RequireError, _Error);

  function RequireError(message) {
    _classCallCheck(this, RequireError);

    return _possibleConstructorReturn(this, _getPrototypeOf(RequireError).call(this, message));
  }

  return RequireError;
}(_wrapNativeSuper(Error));
RequireError.prototype.name = RequireError.name;

function main(meta) {
  for (var _i = 0; _i < mains.length; _i++) {
    var key = mains[_i];
    var value = meta[key];

    if (typeof value === "string") {
      return extensionRe.test(value) ? value : "".concat(value, ".js");
    }
  }
}

function parseIdentifier(identifier) {
  var match = identifierRe.exec(identifier);
  return match && {
    name: match[1],
    version: match[2],
    path: match[3]
  };
}

function resolveMeta(target) {
  var url = "".concat(origin).concat(target.name).concat(target.version ? "@".concat(target.version) : "", "/package.json");
  var meta = metas.get(url);
  if (!meta) metas.set(url, meta = fetch(url).then(function (response) {
    if (!response.ok) throw new RequireError("unable to load package.json");
    if (response.redirected && !metas.has(response.url)) metas.set(response.url, meta);
    return response.json();
  }));
  return meta;
}

function resolve(_x, _x2) {
  return _resolve.apply(this, arguments);
}

function _resolve() {
  _resolve = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(name, base) {
    var target, _meta, meta;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (name.startsWith(origin)) name = name.substring(origin.length);

            if (!/^(\w+:)|\/\//i.test(name)) {
              _context.next = 3;
              break;
            }

            return _context.abrupt("return", name);

          case 3:
            if (!/^[.]{0,2}\//i.test(name)) {
              _context.next = 5;
              break;
            }

            return _context.abrupt("return", new URL(name, base == null ? location : base).href);

          case 5:
            if (!(!name.length || /^[\s._]/.test(name) || /\s$/.test(name))) {
              _context.next = 7;
              break;
            }

            throw new RequireError("illegal name");

          case 7:
            target = parseIdentifier(name);

            if (target) {
              _context.next = 10;
              break;
            }

            return _context.abrupt("return", "".concat(origin).concat(name));

          case 10:
            if (!(!target.version && base != null && base.startsWith(origin))) {
              _context.next = 15;
              break;
            }

            _context.next = 13;
            return resolveMeta(parseIdentifier(base.substring(origin.length)));

          case 13:
            _meta = _context.sent;
            target.version = _meta.dependencies && _meta.dependencies[target.name] || _meta.peerDependencies && _meta.peerDependencies[target.name];

          case 15:
            if (target.path && !extensionRe.test(target.path)) target.path += ".js";

            if (!(target.path && target.version && versionRe.test(target.version))) {
              _context.next = 18;
              break;
            }

            return _context.abrupt("return", "".concat(origin).concat(target.name, "@").concat(target.version, "/").concat(target.path));

          case 18:
            _context.next = 20;
            return resolveMeta(target);

          case 20:
            meta = _context.sent;
            return _context.abrupt("return", "".concat(origin).concat(meta.name, "@").concat(meta.version, "/").concat(target.path || main(meta) || "index.js"));

          case 22:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, this);
  }));
  return _resolve.apply(this, arguments);
}

export var require = requireFrom(resolve);
export function requireFrom(resolver) {
  var cache = new Map();
  var requireBase = requireRelative(null);

  function requireAbsolute(url) {
    if (typeof url !== "string") return url;
    var module = cache.get(url);
    if (!module) cache.set(url, module = new Promise(function (resolve, reject) {
      var script = document.createElement("script");

      script.onload = function () {
        try {
          resolve(queue.pop()(requireRelative(url)));
        } catch (error) {
          reject(new RequireError("invalid module"));
        }

        script.remove();
      };

      script.onerror = function () {
        reject(new RequireError("unable to load module"));
        script.remove();
      };

      script.async = true;
      script.src = url;
      window.define = define;
      document.head.appendChild(script);
    }));
    return module;
  }

  function requireRelative(base) {
    return function (name) {
      return Promise.resolve(resolver(name, base)).then(requireAbsolute);
    };
  }

  function requireAlias(aliases) {
    return requireFrom(function (name, base) {
      if (name in aliases) {
        name = aliases[name], base = null;
        if (typeof name !== "string") return name;
      }

      return resolver(name, base);
    });
  }

  function require(name) {
    return arguments.length > 1 ? Promise.all(map.call(arguments, requireBase)).then(merge) : requireBase(name);
  }

  require.alias = requireAlias;
  require.resolve = resolver;
  return require;
}

function merge(modules) {
  var o = {};
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = modules[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var m = _step.value;

      for (var k in m) {
        if (hasOwnProperty.call(m, k)) {
          if (m[k] == null) Object.defineProperty(o, k, {
            get: getter(m, k)
          });else o[k] = m[k];
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return o;
}

function getter(object, name) {
  return function () {
    return object[name];
  };
}

function isexports(name) {
  return name + "" === "exports";
}

function define(name, dependencies, factory) {
  var n = arguments.length;
  if (n < 2) factory = name, dependencies = [];else if (n < 3) factory = dependencies, dependencies = typeof name === "string" ? [] : name;
  queue.push(some.call(dependencies, isexports) ? function (require) {
    var exports = {};
    return Promise.all(map.call(dependencies, function (name) {
      return isexports(name += "") ? exports : require(name);
    })).then(function (dependencies) {
      factory.apply(null, dependencies);
      return exports;
    });
  } : function (require) {
    return Promise.all(map.call(dependencies, require)).then(function (dependencies) {
      return typeof factory === "function" ? factory.apply(null, dependencies) : factory;
    });
  });
}

define.amd = {};